<template>
  <div class="selftips" :style="{ borderLeft: `5px solid ${bordercolor}` }">
    <span>{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: "SelfTips",
  props: {
    title: {
      default: "标题",
      type: String,
    },
    bordercolor: {
      type: String,
      default: "50bfff",
    },
  },
};
</script>

<style lang="less" scoped>
.selftips {
  font-size: 16px;
  color: #333;
  padding: 8px 16px;
  border-radius: 4px;
  border-left: 5px solid #50bfff;
  margin: 10px 10px 20px;
}
</style>